export default "__VITE_ASSET__cdbe6dad__"